import React from 'react';
import PropTypes from 'prop-types';

import { FormattedHTMLMessage } from 'component-utilities/intl';
import { momentDate } from 'component-utilities/dates/dates';

import LoginBase, { LoginForm, LoginFooter, LoginFormLinks } from 'v-c/Login';

const copyrightText = (
    <FormattedHTMLMessage
        id="components.login.footer.copyright"
        values={{ year: momentDate().format('YYYY') }}
    />
);

function LoginWrapper({
    children,
    links,
    termsAndConditionsLink,
    isAccountDeleted,
    viewLogo,
    renderFlashMessages,
    section,
}) {
    return (
        <div>
            {!isAccountDeleted && (
                <LoginBase>
                    {viewLogo}
                    <LoginForm section={section}>
                        {renderFlashMessages}
                        {children}
                        <LoginFormLinks links={links} />
                    </LoginForm>
                    <LoginFooter
                        copyrightText={copyrightText}
                        termsAndConditionsLink={termsAndConditionsLink}
                    />
                </LoginBase>
            )}
            {isAccountDeleted && (
                <div style={{ marginTop: '30px', textAlign: 'center' }}>
                    <FormattedHTMLMessage id="components.login.deleted_account" />
                </div>
            )}
        </div>
    );
}

LoginWrapper.propTypes = {
    children: PropTypes.node.isRequired,
    links: PropTypes.object.isRequired,
    termsAndConditionsLink: PropTypes.string,
    isAccountDeleted: PropTypes.bool,
    viewLogo: PropTypes.object,
    renderFlashMessages: PropTypes.object,
    section: PropTypes.string.isRequired,
};

LoginWrapper.defaultProps = {
    termsAndConditionsLink: '',
    isAccountDeleted: false,
    viewLogo: null,
    renderFlashMessages: null,
};

export default LoginWrapper;
